function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.47332 7.19378L11.5801 5.39925L1.29735 1.29742L5.39855 11.5815L7.19299 8.47458L11.5622 12.8442L12.8428 11.5634L8.47332 7.19378ZM13.8157 12.0046L12.0035 13.8171C11.8865 13.9342 11.7277 14 11.5622 14C11.3967 14 11.2379 13.9342 11.1209 13.8171L7.40722 10.1031L5.87691 12.7527C5.7574 12.9598 5.53006 13.0803 5.29153 13.063C5.05301 13.0458 4.84534 12.8938 4.75674 12.6717L0.0444281 0.855244C-0.0480034 0.623631 0.00647494 0.359218 0.182855 0.182775C0.359235 0.00645803 0.623712 -0.0480209 0.855325 0.0444735L12.6704 4.75754C12.8925 4.84607 13.0444 5.05375 13.0616 5.29227C13.0788 5.53073 12.9584 5.75801 12.7513 5.87759L10.1017 7.40802L13.8157 11.1221C14.0594 11.3658 14.0594 11.7609 13.8157 12.0046Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/cursor.78710d32.svg";
export { SvgComponent as ReactComponent };